import React from 'react';

interface OverviewTabProps {
  athleteData: any;
  isDark: boolean;
  getValidatedStats: () => any;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ athleteData, isDark, getValidatedStats }) => {
  const validatedStats = getValidatedStats();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {/* Quick Stats Cards - Using validated data */}
      {(() => {
        return [
          {
            title: 'Recovery Score',
            value: validatedStats?.recovery.latest_recovery ? `${validatedStats.recovery.latest_recovery.toFixed(0)}%` : 'N/A',
            subtitle: `Avg: ${validatedStats?.recovery.average_recovery ? validatedStats.recovery.average_recovery.toFixed(0) : 'N/A'}%`,
            icon: '💚',
            gradient: 'from-green-500 to-emerald-600',
            bgGradient: `${isDark ? 'from-green-900/20 to-emerald-800/20' : 'from-green-50 to-emerald-100'}`
          },
          {
            title: 'Sleep Quality',
            value: validatedStats?.sleep.latest_quality ? `${validatedStats.sleep.latest_quality.toFixed(0)}%` : 'N/A',
            subtitle: `${validatedStats?.sleep.latest_duration ? validatedStats.sleep.latest_duration.toFixed(1) : 'N/A'}h duration`,
            icon: '😴',
            gradient: 'from-purple-500 to-purple-600',
            bgGradient: `${isDark ? 'from-purple-900/20 to-purple-800/20' : 'from-purple-50 to-purple-100'}`
          },
          {
            title: 'Daily Strain',
            value: validatedStats?.activity.latest_strain ? `${validatedStats.activity.latest_strain.toFixed(1)}` : 'N/A',
            subtitle: `Avg: ${validatedStats?.activity.average_strain ? validatedStats.activity.average_strain.toFixed(1) : 'N/A'}`,
            icon: '🔥',
            gradient: 'from-orange-500 to-red-500',
            bgGradient: `${isDark ? 'from-orange-900/20 to-red-800/20' : 'from-orange-50 to-red-100'}`
          },
          {
            title: 'Data Points',
            value: validatedStats?.recovery.data_points.toString() || '0',
            subtitle: `${athleteData.data_summary.analysis_period_days} day period`,
            icon: '📈',
            gradient: 'from-blue-500 to-blue-600',
            bgGradient: `${isDark ? 'from-blue-900/20 to-blue-800/20' : 'from-blue-50 to-blue-100'}`
          }
        ];
      })().map((stat, index) => (
        <div
          key={stat.title}
          className={`bg-gradient-to-br ${stat.bgGradient} rounded-2xl p-6 border ${isDark ? 'border-gray-700/50' : 'border-gray-200/50'} transform hover:scale-105 transition-all duration-300`}
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 bg-gradient-to-r ${stat.gradient} rounded-xl flex items-center justify-center text-white text-xl`}>
              {stat.icon}
            </div>
            <div className="text-right">
              <div className="text-2xl font-bold theme-text-primary">{stat.value}</div>
              <div className="text-sm theme-text-secondary font-medium">{stat.subtitle}</div>
            </div>
          </div>
          <div className="text-lg font-semibold theme-text-primary">{stat.title}</div>
        </div>
      ))}
    </div>
  );
};

export default OverviewTab; 